import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo.png";

function Main() {
  const [headerScroll, setheaderScroll] = useState(false);
  const [mobile, setmobile] = useState();

  useEffect(() => {
    const fixedHeader = () => {
      if (window.pageYOffset > 150) {
        setheaderScroll(true);
      } else {
        setheaderScroll(false);
      }
    };
    window.addEventListener("scroll", fixedHeader);
  }, []);

  return (
    <>
      <header className={headerScroll ? "fixed fix_style" : "fixed"}>
        <div className="container">
          <nav className="navbar navbar-expand-lg">
            <Link className="navbar-brand" to="/">
              <img src={logo} alt="" />
            </Link>
            <button
              className={`navbar-toggler ${mobile && "collapsed"}`}
              onClick={() => setmobile(mobile === true ? false : true)}
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <div
                className={`toggle-wrap ${mobile && "active"}`}
                onClick={() => setmobile(mobile === true ? false : true)}
              >
                <span className="toggle-bar"></span>
              </div>
            </button>
            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav ml-auto">
                <li className="nav-item active">
                  <Link className="nav-link" to="/">
                    Accueil
                  </Link>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#about">
                    À propos
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#features">
                    Fonctionnalités
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#reviews">
                    Avis
                  </a>
                </li>

                <li className="nav-item">
                  <a className="nav-link" href="#pricing">
                    Prix
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#faq">
                    Faq
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#contact">
                    Contact
                  </a>
                </li>
                <li className="nav-item">
                  <div className="btn_block">
                    <a className="nav-link dark_btn" href="#contact">
                      Télécharger
                    </a>
                    <div className="btn_bottom" />
                  </div>
                </li>
              </ul>
            </div>

            {mobile && (
              <>
                <div
                  className={`navbar-collapse collapse ${mobile && "show"}`}
                  id="navbarSupportedContent"
                  style={{}}
                >
                  <ul className="navbar-nav ml-auto">
                    <li className="nav-item active">
                      <Link className="nav-link" to="/">
                        Accueil
                      </Link>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="#about">
                        À propos
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="#features">
                        Fonctionnalités
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="#reviews">
                        Avis
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="#pricing">
                        Prix
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="#faq">
                        Faq
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="#contact">
                        Contact
                      </a>
                    </li>
                    <li className="nav-item">
                      <div className="btn_block">
                        <a className="nav-link dark_btn" href="#contact">
                          Télécharger
                        </a>
                        <div className="btn_bottom" />
                      </div>
                    </li>
                  </ul>
                </div>
              </>
            )}
          </nav>
        </div>
      </header>
    </>
  );
}

export default Main;
